// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

jQuery("#nav0").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 2,
  scroll: 2,
});

new Swiper("#swiper-btn", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 5000,
  },
  loop: true,
  spaceBetween: 30,
});
new Swiper("#swiper2", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
  centeredSlides: true,
  spaceBetween: 39,
  slidesPerView: "auto",
  navigation: {
    nextEl: ".swiper-btn-next",
    prevEl: ".swiper-btn-prev",
  },
});
var thumbsp = new Swiper("#thumbs-p", {
  spaceBetween: 23,
  slidesPerView: 5,
  watchSlidesVisibility: true, //防止不可点击
});
let swiper = new Swiper("#swiper-p1", {
  thumbs: {
    swiper: thumbsp,
  },
  spaceBetween: 20,
  navigation: {
    prevEl: ".button-prev2",
    nextEl: ".button-next2",
  },
});
// 处理加入购物车事件
function handleAddToCart(num) {
  if (num > 0) {
    $("#cardNum").html(num).show();
    $(".sp-top-btn").addClass("sp-high");
    $(".sp-top-btn span").html("Sjekk ut");
    $(".sp-header-top .sp-cart").addClass("on");
  } else {
    $("#cardNum").html(0).hide();

    $(".sp-top-btn").removeClass("sp-high");
    $(".sp-top-btn span").html("KJØP NÅ");
    $(".sp-header-top .sp-cart").removeClass("on");
  }
}
handleAddToCart(window.cartCount);

$('.sp-top-btn').click(function(){
  $.ajax({
  type: "POST",
  url: "/cart/",
  success: function () {
    $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
      let cartNum = result.item_count
      let cartItem = result.items
      let url = '/cart/'
      if(cartNum > 0){
        cartItem.forEach(function(cartItem) {
            url += cartItem.id + ':' + cartItem.quantity + ','
        });
        window.location.href =  url
      }
    });
  },
  dataType: "json",
});
})

let prods = window.product
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  let style = $('#sp-style div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == style)[0]
}
function changePrice(){
  let num = $('#calcNumber').val()
  let price = (getCur().price / 100).toFixed(2)
  let compare = (getCur().compare_at_price / 100).toFixed(2)
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  $('.product-infos .price-group .price1 span').html(price)
  $('.product-infos .price-group .price2 span').html(compare)
  let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  $(".product-infos .price3 span").html(off_font);
}

$('.buyNow').click(function(){
  let num = $('#calcNumber').val()
  window.location.href = '/cart/' + getCur().id + ':' + num
})

// 弹窗内尺码表切换
$(".sp-size-part2 .btn-wrap").click(function () {
  $(this).addClass("active").siblings().removeClass("active");
  let index = $(this).index();
  $(".sp-size-part2 .sp-size1").eq(index).show().siblings(".sp-size1").hide();
});
$(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
  }
});
$(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
});

// 商品弹窗状态
let _popShow = false;

// 展示尺码弹窗
$(".size-btn").click(function () {
  $(".sp-mask").css("display", "flex");
  $(".sp-mask .size-pop").show();
  $(".sp-mask .img-pop").hide();
});

// 点击放大按钮
$(".sp-large,.p-img").click(function () {
  $(".sp-mask").css("display", "flex");
  let _index = $("#sp-color .active").index();

  $(".sp-mask .img-pop .sp-img")[0].src = $(".product-part .p-img")[0].src;

  $(".sp-mask .img-pop").css("display", "flex");
  $(".sp-mask .size-pop").hide();
});
// 点击页面内尺码表
$(".sp-size-part .sp-img").click(function () {
  $(".sp-mask").css("display", "flex");
  console.log($(this));
  $(".sp-mask .img-pop .sp-img")[0].src = $(this)[0].src;

  $(".sp-mask .img-pop").css("display", "flex");
  $(".sp-mask .size-pop").hide();
});

// 关闭弹窗按钮
$(".close-btn, .sp-close-pop").click(function () {
  $(".sp-mask").hide();
  // $(".sp-mask2").hide();
});

$(".sp-mask").click(function (e) {
  if ($(e.target).closest(".sp-mask .choose-btn").length > 0) {
  } else {
    $(".sp-mask").hide();
  }
});

let spImgList = [
];
$(function () {
  $("#sp-color .option").click(function(){
    const index =$(this).index()
    $(".img-wrap img").hide().removeClass("isshow")
    $(".img-wrap img").eq(index).show().addClass("isshow")
  })
  $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    // style选项
    let colorOptions = $("#sp-color .option.active").index();
    let styleOptions = $("#sp-style .option.active").index();
    changePrice()
  });

  // style选项
  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
  });
  
  $(".product-part .cart-btn").click(function () {
    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    };
    
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
          handleAddToCart(result.item_count);
        });
      },
      dataType: "json",
    });

    var img = $(this).parents(".product-part").find(".isshow");

    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $(".product-part").append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      background: "#e7e9ef",
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top: finish[0].offsetTop + $(".time-part").height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
  });
});

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }
  let banner1List = [
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/img1-1_ff8b10bd-d9c4-497b-bfdf-6ed5a3ea739a.jpg?v=1716196676",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/img1-2_85345f39-f8b1-40e9-9431-2988664fd5b5.jpg?v=1716196676",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/img1-3_9abb70cb-144a-49cb-a4c2-e3f2f20b06c1.jpg?v=1716196676",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/img1-4_7d3a85e3-a3fb-4d97-a4b9-f2fdf9a0161f.jpg?v=1716196676",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/img1-5_8a266280-de5c-4166-aada-26b4a08d4942.jpg?v=1716196676",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/img1-6_82746746-3017-4bd3-a760-1812754299c1.jpg?v=1716196676",
  ];
  let banner1List2 = [
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/img1-1-s_539bb6e5-b295-478e-8e5d-541c865619ee.png?v=1716196675",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/img1-2-s_9bb14f2f-ec9e-4f2d-ac58-4d747c834323.png?v=1716196675",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/img1-3-s_f0c933bf-ea05-48bd-a6dc-813aaa6bfeb1.png?v=1716196675",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/img1-4-s_b3de3a97-d175-4e7e-8acb-a4039e923a17.png?v=1716196676",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/img1-5-s_82a46674-0813-4045-b0eb-e5c6953b06b6.png?v=1716196676",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/img1-6-s_0052cc70-61da-4292-ac50-43b2fe9d6fb6.png?v=1716196674",
  ];
  let banner1List3 = [
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/b1.jpg",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/b2.jpg",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/b3.jpg",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/b4.jpg",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/b5.jpg",
    "https://cdn.shopify.com/s/files/1/0778/6233/8838/files/b6.jpg",
  ];
  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);
    preloadImages(banner1List);
    preloadImages(banner1List2);
    preloadImages(banner1List3);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("buyBox"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top: offsetTop * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();
